









import { Vue, Component, Prop } from 'vue-property-decorator';

type BadgeVariant = 'success';

@Component({})
export default class BaseBadge extends Vue {
    @Prop({ default: 'success' }) variant!: BadgeVariant
}
